import { useState } from 'react';
import { Button, Checkbox, Flex, Form, Table } from 'antd';
import type { FormProps, TableProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// services
import NotificationService from 'core/services/notification';

// components
import LanguageButton from 'components/language-button/language-button';
import PageTitle from 'components/title/title';
import FormElement from 'components/formElement/formElement';
import { MortgageRequest } from '../models/mortgage';
import StatusComponent from 'components/status/status';
import ListButton from 'components/listButton/listButton';
import NoData from 'components/noData/noData';

function BusinessMortgageListPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [requests, setRequests] = useState<MortgageRequest[]>([
		{
			id: '1234567',
			status: 'active',
			created_at: '20th Nov, 6:00PM',
			client_id: '123456789',
		},
	]);

	const columns: TableProps['columns'] = [
		{
			title: t('MORTGAGE.REQUEST_NUMBER'),
			dataIndex: 'id',
			key: 'id',
		},
		{
			title: t('COMMON.STATUS'),
			dataIndex: 'status',
			key: 'status',
			render: (status) => <StatusComponent text={t(`COMMON.${status.toUpperCase()}`)} color={'green'} />,
		},
		{
			title: t('MORTGAGE.REQUEST_DATE'),
			dataIndex: 'created_at',
			key: 'created_at',
		},
		{
			title: t('MORTGAGE.CLIENT_ID'),
			dataIndex: 'client_id',
			key: 'client_id',
		},
		{
			title: t('COMMON.ACTIONS'),
			dataIndex: 'id',
			key: 'actions',
			render: (id) => (
				<Flex gap={10} justify="center">
					<ListButton type="view" text={t('COMMON.VIEW')} onClick={() => navigate(id)} />
					<ListButton type="request" text={t('MORTGAGE.HISTORY')} onClick={() => navigate(`activities/${id}`)} />
				</Flex>
			),
		},
	];

	return (
		<>
			<PageTitle name={t('TITLE.MORTGAGES')} />

			<Table
				className="mt-5 bordered"
				columns={columns}
				dataSource={requests}
				scroll={{ x: 600 }}
				rowKey="id"
				pagination={{
					pageSize: 5,
					total: requests.length,
					showSizeChanger: false,
				}}
				locale={{ emptyText: <NoData /> }}
			/>
		</>
	);
}

export default BusinessMortgageListPage;
